import { string, func } from 'prop-types'
import AppBar from '@mui/material/AppBar'
import IconButton from '@mui/material/IconButton'
import MenuIcon from '@mui/icons-material/Menu'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import logo from '../../images/Ziptie_White.png'
import blueLogo from '../../images/Ziptie_Blue.png'
import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'

const HeaderRoot = styled(Box)(({ theme }) => ({
  height: 56,
  [theme.breakpoints.up('xs') + ' and (orientation: landscape)']: {
    height: 48,
  },
  [theme.breakpoints.up('sm')]: {
    height: 64,
  },
}))

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  [`&.hasSecondaryNav`]: {
    paddingBottom: 48,
  },
}))

export function Header({ title, menuAction }) {
  return (
    <HeaderRoot>
      <StyledAppBar color="primary">
        <Toolbar>
          {menuAction && (
            <IconButton
              onClick={menuAction}
              aria-label="Menu"
              size="large"
              sx={{ color: 'primary.contrastText' }}
            >
              <MenuIcon />
            </IconButton>
          )}
          <img
            src={process.env.REACT_APP_ENV === 'stg' ? blueLogo : logo}
            alt=" "
            style={{
              height: 40,
              width: 30,
              margin: '0 18px 0 6px',
              display: 'inline-block',
              verticalAlign: 'middle',
            }}
          />
          <Typography variant="h6" color="inherit">
            {title}
          </Typography>
          {process.env.REACT_APP_ENV === 'qa' ||
          process.env.REACT_APP_ENV === 'stg' ? (
            <Typography
              variant="h6"
              sx={{
                marginLeft: 'auto',
                px: 1.5,
                py: 0.25,
                border: '1px solid',
                borderColor: 'primary.contrastText',
                borderRadius: 1,
                color: 'primary.contrastText',
                opacity: 0.8,
              }}
            >
              ZIPTIE DEVELOPMENT ENVIRONMENT
            </Typography>
          ) : (
            ''
          )}
        </Toolbar>
      </StyledAppBar>
    </HeaderRoot>
  )
}

Header.displayName = 'Header'

Header.propTypes = {
  title: string.isRequired,
  menuAction: func,
}

Header.defaultProps = {}

export default Header
